import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initDiagnostics } from './utils/diagnostics/diagnosticsBuffer';

initDiagnostics();

// Report client errors to server for PM2 logging
function reportError(payload) {
  try {
    fetch('/api/client-errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...payload, url: window.location.href, userAgent: navigator.userAgent }),
    }).catch(() => {});
  } catch {
    // Silently ignore reporting failures
  }
}

// Catch uncaught JS errors (event handlers, synchronous throws, etc.)
window.addEventListener('error', (event) => {
  reportError({
    error: event.message || 'Unknown error',
    source: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : null,
    type: 'uncaught',
  });
});

// Catch unhandled promise rejections (async/await, fetch, etc.)
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  reportError({
    error: reason?.message || reason?.toString() || 'Unhandled promise rejection',
    stack: reason?.stack || null,
    type: 'unhandledrejection',
    requestId: reason?.config?.metadata?.requestId || null,
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
